var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _rect, _rect2, _rect3, _path9, _path10, _path11, _path12, _rect4, _rect5, _rect6, _path13, _rect7, _rect8, _rect9, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 353,
    viewBox: "0 0 630 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.098 217.985L337.58 132.04C337.508 130.847 338.266 128.638 341.879 129.354L511.777 129.354C513.524 128.981 517.677 129.534 520.313 134.726L563.757 195.156C565.095 197.021 568.58 200.751 571.816 200.751L628.211 200.751",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.356 218.209L292.839 132.183C292.925 130.988 292.191 128.777 288.567 129.494L118.534 129.494C116.789 129.121 112.627 129.674 109.93 134.872L65.7724 195.373C64.4125 197.24 60.8827 200.975 57.644 200.975L1.20424 200.975",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M291.807 316.911L291.767 324.073C291.84 325.117 291.368 327.206 288.894 327.206L219.649 327.206C219.015 327.206 217.277 325.953 215.401 320.94C214.99 319.838 213.053 315.017 210.105 307.735M1.08721 221.79L20.9562 221.79M137.019 189.784L136.999 193.365L137.04 185.979M137.019 189.784L148.262 189.784M137.019 189.784L125.776 189.784M148.262 189.784L159.505 189.784C161.599 189.784 163.061 192.172 163.53 193.365C173.625 218.091 190.068 258.404 201.75 287.144M148.262 189.784L148.242 193.365L148.283 185.979M125.776 189.784L114.532 189.784C113.105 189.635 109.581 190.142 106.898 193.365L96.477 205.787M125.776 189.784L125.755 193.365L125.797 185.979M96.477 205.787L86.0563 218.209C84.8599 219.402 82.0862 221.79 80.5633 221.79L60.6943 221.79M96.477 205.787L106.828 205.787L86.1261 205.787M40.8253 221.79L40.7989 226.49M40.8253 221.79L60.6943 221.79M40.8253 221.79L20.9562 221.79M60.6943 221.79L60.6679 226.49M20.9562 221.79L20.9298 226.49M210.105 307.735L221.662 307.735M210.105 307.735C208.877 304.7 207.474 301.238 205.932 297.439M205.932 297.439L221.72 297.439M205.932 297.439C204.629 294.229 203.228 290.779 201.75 287.144M201.75 287.144L221.778 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M336.55 316.911L336.51 324.073C336.425 325.117 336.873 327.206 339.348 327.206L408.592 327.206C409.227 327.206 410.979 325.953 412.91 320.94C413.335 319.838 415.326 315.017 418.355 307.735M628.338 221.79L608.469 221.79M492.766 189.784L492.746 193.365L492.787 185.979M492.766 189.784L481.523 189.784M492.766 189.784L504.009 189.784M481.523 189.784L470.28 189.784C468.186 189.784 466.697 192.172 466.214 193.365C455.842 218.091 438.946 258.404 426.941 287.144M481.523 189.784L481.503 193.365L481.544 185.979M504.009 189.784L515.253 189.784C516.681 189.635 520.2 190.142 522.847 193.365L533.128 205.787M504.009 189.784L503.989 193.365L504.031 185.979M533.128 205.787L543.409 218.209C544.592 219.402 547.339 221.79 548.862 221.79L568.731 221.79M533.128 205.787L522.777 205.787L543.479 205.787M588.6 221.79L588.574 226.49M588.6 221.79L568.731 221.79M588.6 221.79L608.469 221.79M568.731 221.79L568.705 226.49M608.469 221.79L608.443 226.49M418.355 307.735L406.798 307.735M418.355 307.735C419.617 304.7 421.059 301.238 422.644 297.439M422.644 297.439L406.856 297.439M422.644 297.439C423.983 294.229 425.423 290.779 426.941 287.144M426.941 287.144L406.913 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M315.296 201.87L316.292 24.6092C316.296 23.8631 316.78 22.371 318.684 22.371L518.802 22.371C521.022 22.4456 525.468 21.8339 525.485 18.79C525.502 15.7461 525.547 7.6739 525.568 4.01826C525.493 3.12301 525.916 1.33249 528.2 1.33249L619.167 0.999998",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M314.795 201.87L315.79 24.6092C315.794 23.8631 315.328 22.371 313.427 22.371L113.613 22.371C111.395 22.4456 114.968 21.6537 114.985 18.6099C115.002 15.566 115.048 7.49375 115.068 3.83812C115.153 2.94286 106.746 1.33249 104.465 1.33249L11.2563 1.15234",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M314.554 337.726L314.508 345.783C314.339 347.723 315.047 351.602 319.235 351.602L492.226 351.602C493.494 351.751 496.942 350.886 500.585 346.231L557.622 274.162C558.66 272.894 561.165 270.357 562.878 270.357L627.839 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M313.562 337.726L313.517 345.783C313.665 347.723 312.913 351.602 308.725 351.602L135.734 351.602C134.464 351.751 131.027 350.886 127.436 346.231L71.2079 274.162C70.1839 272.894 67.7076 270.357 65.9943 270.357L1.03329 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 96.6099,
    y2: -0.5,
    transform: "matrix(1 1.15926e-09 -0.00561531 0.999984 532.364 22.5947)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 96.6099,
    y2: -0.5,
    transform: "matrix(1 1.15926e-09 -0.00561531 0.999984 2.68164 22.595)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.90509,
    height: 14.772,
    transform: "matrix(1 4.36203e-10 -0.00561531 0.999984 291.636 143.537)",
    fill: "url(#paint0_linear_439_808)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.7988,
    height: 50.1352,
    transform: "matrix(1 9.21643e-10 -0.00561531 0.999984 313.942 127.423)",
    fill: "url(#paint1_linear_439_808)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.90509,
    height: 14.772,
    transform: "matrix(1 4.36203e-10 -0.00561531 0.999984 336.406 143.537)",
    fill: "url(#paint2_linear_439_808)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M357.495 327.009H339.193C338.368 327.176 336.719 326.809 336.719 324.009C336.719 321.209 336.719 316 336.719 310",
    stroke: "url(#paint3_linear_439_808)",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.437 327.009H288.739C289.563 327.176 291.212 326.809 291.212 324.009C291.212 321.209 291.212 316 291.212 310",
    stroke: "url(#paint4_linear_439_808)",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M334.741 351.009H316.439C315.614 351.176 313.965 350.809 313.965 348.009C313.965 345.209 313.965 340 313.965 334",
    stroke: "url(#paint5_linear_439_808)",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M293.19 351.009H311.492C312.317 351.176 313.966 350.809 313.966 348.009C313.966 345.209 313.966 340 313.966 334",
    stroke: "url(#paint6_linear_439_808)",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 613.737 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 598.972 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 584.208 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M569.439 193.664C569.441 193.252 569.777 192.918 570.189 192.918L578.397 192.918C579.502 192.918 580.392 193.813 580.386 194.918L580.382 195.568C580.377 196.577 579.555 197.394 578.546 197.394L573.148 197.394C571.088 197.394 569.427 195.724 569.439 193.664Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 16.4893 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 31.2549 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 46.0186 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.78 193.664C60.7823 193.252 60.4502 192.918 60.0381 192.918L51.8299 192.918C50.7253 192.918 49.8249 193.813 49.8187 194.918L49.815 195.568C49.8094 196.577 50.6222 197.394 51.6305 197.394L57.0287 197.394C59.0889 197.394 60.7684 195.724 60.78 193.664Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_439_808",
    x1: 0.952545,
    y1: 0,
    x2: 0.952545,
    y2: 14.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_439_808",
    x1: 0.899399,
    y1: 0,
    x2: 0.899399,
    y2: 50.1352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_439_808",
    x1: 0.952545,
    y1: 0,
    x2: 0.952545,
    y2: 14.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_439_808",
    x1: 334.741,
    y1: 339,
    x2: 328.299,
    y2: 336.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_439_808",
    x1: 293.19,
    y1: 339,
    x2: 299.632,
    y2: 336.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_439_808",
    x1: 311.987,
    y1: 363,
    x2: 305.545,
    y2: 360.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_439_808",
    x1: 315.944,
    y1: 363,
    x2: 322.386,
    y2: 360.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame4);
export default __webpack_public_path__ + "static/media/card1-frame4.8e13cee42a4d90112b7eca7980ce8899.svg";
export { ForwardRef as ReactComponent };